<template>
  <el-dropdown size="normal" trigger="click" placement="top-start" :hide-on-click="false" @command="handleCommand">
    <el-button size="small"
      ><i class="material-icons">filter_list</i><i class="el-icon-arrow-down el-icon--right"></i
    ></el-button>
    <el-dropdown-menu slot="dropdown">
      <div class="flex gaps title">
        <div class="box grow">({{ filtersApplied }}) Filters Applied</div>
        <div class="box center btn" @click="clear">clear</div>
        <div class="box center btn" @click="reset">reset</div>
      </div>
      <div class="group">
        <div class="label">Automation</div>
        <el-dropdown-item command="automated" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: automated }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            Confluera automated
          </div>
        </el-dropdown-item>
      </div>
      <div class="group">
        <div class="label">Status</div>
        <el-dropdown-item command="default" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: checkboxes.default }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            <div class="tag pending" size="mini">awaiting action</div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="invalid" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: checkboxes.invalid }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            <div class="tag" size="mini">expired</div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="dismissed" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: checkboxes.dismissed }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            <div class="tag dismissed" size="mini">dismissed</div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="done" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: checkboxes.done }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            <div class="tag success" size="mini">done</div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="pending" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: checkboxes.pending }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            <div class="tag warning" size="mini">in progress</div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="executed" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: checkboxes.executed }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            <div class="tag executed" size="mini">executed</div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="failed" class="flex gaps">
          <div class="box center left">
            <div class="checkbox" v-bind:class="{ checked: checkboxes.failed }">
              <div class="checkbox-inner"></div>
            </div>
          </div>
          <div class="box center left">
            <div class="tag danger" size="mini">failed</div>
          </div>
        </el-dropdown-item>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'BlockingResponseDropdown',
  props: {
    selection: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      automated: false,
      checkboxes: {
        default: false,
        invalid: false,
        dismissed: false,
        done: false,
        pending: false,
        executed: false,
        failed: false
      }
    }
  },
  created () {
    this.update()
  },
  computed: {
    filtersApplied () {
      let num = this.selection.length
      if (this.automated) {
        num++
      }
      return num
    }
  },
  methods: {
    clear () {
      this.automated = false
      this.selection.splice(0, this.selection.length)
      this.update()
    },
    reset () {
      this.automated = false
      this.selection.splice(0, this.selection.length, 'default', 'pending', 'executed', 'failed')
      this.update()
    },
    update () {
      this.$emit('update')
      Object.keys(this.checkboxes).forEach(value => {
        this.checkboxes[value] = this.selection.indexOf(value) > -1
      })
    },
    handleCommand (command) {
      switch (command) {
        case 'automated':
          this.automated = !this.automated
          break
        default:
          let index = this.selection.indexOf(command)
          if (index > -1) {
            this.selection.splice(index, 1)
          } else {
            this.selection.push(command)
          }
          break
      }
      this.update()
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/icon.css';

.el-dropdown {
  position: absolute;
  left: 0;
  top: 0;

  .el-button {
    padding-left: 28px;

    .material-icons {
      position: absolute;
      top: 4px;
      left: 6px;
    }
  }
}

.el-dropdown-menu {
  width: 400px;
  border-color: var(--border-color);

  .title {
    padding: 0 20px 10px 20px;
    font-size: 14px;

    .btn {
      cursor: pointer;
      color: #007ced;
      font-size: 11px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  .group {
    padding-bottom: 5px;
    border-top: 1px solid var(--border-color);

    .label {
      padding: 6px 20px 2px 20px;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .el-dropdown-menu__item {
    margin: 2px 0;
    padding: 5px 20px;
    font-size: 14px;
    line-height: 16px;

    &:focus {
      color: inherit;
      background-color: transparent;
    }

    .checkbox {
      position: relative;
      width: 13px;
      height: 14px;
      border-radius: 2px;
      border: 1px solid var(--border-color);

      .checkbox-inner {
        width: 13px;
        height: 14px;
        border-radius: 1px;
      }

      &.checked {
        .checkbox-inner {
        }

        .checkbox-inner::after {
          position: absolute;
          top: 7px;
          left: 1px;
          color: #888888;
          content: '✕';
          line-height: 0;
        }
      }
    }

    .tag {
      height: 14px;
      padding: 2px 10px;
      font-size: 10px;
      font-weight: bold;
      line-height: 14px;
      text-transform: uppercase;
      white-space: nowrap;
      color: #888888;
      border: solid 1px #e9e9eb;
      border-radius: 4px;
      background: #f4f4f4;

      &.pending {
        color: #888888;
        border-color: #e9e9eb;
        background-color: #ffffff;
      }

      &.dismissed {
        color: #888888;
        border-color: #e9e9eb;
        background-color: #f4f4f4;
      }

      &.executed {
        color: #6b7b8b;
        border-color: #d9ecff;
        background-color: #ecf5ff;
      }

      &.warning {
        color: #e6a23c;
        border-color: #faecd8;
        background-color: #fdf6ec;
      }

      &.success {
        color: #67c23a;
        border-color: #e1f3d8;
        background-color: #f0f9eb;
      }

      &.danger {
        color: #f56c6c;
        border-color: #fde2e2;
        background-color: #fef0f0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dropdown/BlockingResponseDropdown.vue